export const hashString = (str: string) => {
  // Simple implementation of the djb2 hash function
  // Great for speed and simplicity
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return (hash >>> 0).toString(36); // compact base36 string
};

export const hashArray = (arr: string[]) => {
  const sorted = [...arr].sort();
  const str = sorted.join(',');
  return hashString(str);
};
